/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_Feature_Ats_TitleInputs */

const en_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS scoring`)
};

const de_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Bewertung`)
};

const fr_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score ATS`)
};

const es_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación ATS`)
};

const it_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio ATS`)
};

const nl_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-scoring`)
};

const pl_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena ATS`)
};

const fi_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-pisteytys`)
};

const da_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-scoring`)
};

const sv_onboarding_welcome_feature_ats_title = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-betyg`)
};

/**
* | output |
* | --- |
* | "ATS scoring" |
*
* @param {Onboarding_Welcome_Feature_Ats_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_feature_ats_title = /** @type {((inputs?: Onboarding_Welcome_Feature_Ats_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_Feature_Ats_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "fr") return fr_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "es") return es_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "it") return it_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "nl") return nl_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "pl") return pl_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "fi") return fi_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "da") return da_onboarding_welcome_feature_ats_title(inputs)
	if (locale === "sv") return sv_onboarding_welcome_feature_ats_title(inputs)
	return en_onboarding_welcome_feature_ats_title(inputs)
});